import { client } from "@/lib/api";

// Endpoints from docs/review-fixes-contracts.md used by the Session desk and evidence pages.
// Kept apart from lib/api.js so the lanes don't collide; each one tolerates an older backend.

const notFound = (e) => e?.response?.status === 404;

export const deskApi = {
  /** GET /v1/market/calendar?date= — null when the backend predates the calendar endpoint. */
  marketCalendar: (date) =>
    client.get("/v1/market/calendar", { params: { date } }).then((r) => r.data).catch((e) => {
      if (notFound(e) || e?.response?.status === 405) return null;
      throw e;
    }),
  /** POST enqueue; `forceLate` is owner-only and tags the run LATE. 409 RUN_TOO_LATE / RUN_TOO_EARLY otherwise. */
  enqueue: (date, n, { forceLate = false } = {}) =>
    client.post(`/v1/sessions/${date}/runs/${n}/enqueue`, null, { params: forceLate ? { force_late: true } : {} }).then((r) => r.data),
  recalc: (date, n) => client.post(`/v1/sessions/${date}/runs/${n}/recalc`).then((r) => r.data),
  /** GET /v1/history — live sessions only unless includeDemo. */
  history: ({ limit = 80, includeDemo = false } = {}) =>
    client.get("/v1/history", { params: { limit, include_demo: includeDemo } }).then((r) => r.data),
  /** GET /v1/scoring/cost-of-no?days= — null when the endpoint is absent (404). */
  /** GET /v1/paper-strategies[?date=] — advisory-only paper tracking; null when the endpoint is absent. */
  paperStrategies: (date) =>
    client.get("/v1/paper-strategies", { params: date ? { date } : {} }).then((r) => r.data).catch((e) => {
      if (notFound(e)) return null;
      throw e;
    }),
  /** POST /v1/paper-strategies/ai-desk — owner: AI desk switch and monthly model budget (paper only). */
  setAiDesk: (body) => client.post("/v1/paper-strategies/ai-desk", body).then((r) => r.data),
  costOfNo: (days) =>
    client.get("/v1/scoring/cost-of-no", { params: { days } }).then((r) => r.data).catch((e) => {
      if (notFound(e)) return null;
      throw e;
    }),
};
